import React from 'react'
import PT from 'prop-types'

import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { compose, lifecycle } from 'recompose'

import {
  removeFavouriteVenue,
  addFavouriteVenue,
  fetchFavouriteVenues,
} from 'store/favourites'

import {
  selectFavouriteVenues,
  selectFavouriteVenue,
} from 'store/favourites/selectors'

import { types, show } from 'store/modals'

import withAuthState from './withAuthState'

export const withRedux = connect(
  createSelector(
    selectFavouriteVenues,
    selectFavouriteVenue,
    ({ isLoading, isLoaded }, favourite) => {
      return {
        isFavourite: !!favourite,
        isLoading,
        isLoaded,
      }
    },
  ),
  {
    removeFavouriteVenue,
    addFavouriteVenue,
    fetchFavouriteVenues,
    show,
  },
)

export const withLifecycle = lifecycle({
  componentDidMount() {
    if (!this.props.isLoaded && this.props.isAuthenticated) {
      this.props.fetchFavouriteVenues()
    }
  },
})

export const withFavouriteVenue = compose(
  withRedux,
  withAuthState,
  withLifecycle,
)

class VenueFavouriteHandler extends React.Component {
  state = {
    isFavourite: null,
  }

  static propTypes = {
    addFavouriteVenue: PT.func,
    id: PT.number,
    isFavourite: PT.bool,
    isLoading: PT.bool,
    isAuthenticated: PT.bool,
    removeFavouriteVenue: PT.func,
  }

  toggle = async () => {
    try {
      const {
        addFavouriteVenue,
        id,
        isFavourite,
        isLoading,
        removeFavouriteVenue,
        isAuthenticated,
        show,
      } = this.props

      if (isLoading) return

      if (!isAuthenticated) {
        show(types.LOGIN)
        return
      }

      this.setState({ isFavourite: !isFavourite })

      if (isFavourite) {
        await removeFavouriteVenue(id)
      } else {
        await addFavouriteVenue(id)
      }
    } catch (err) {
      console.error(err)
      this.setState({ isFavourite: null })
    }
  }

  get isFavourite() {
    const { isFavourite } = this.props

    let isChecked = isFavourite

    if (this.state.isFavourite !== null) {
      isChecked = this.state.isFavourite
    }

    return isChecked
  }

  render() {
    const { isLoading } = this.props
    return this.props.children({
      isFavourite: this.isFavourite,
      isLoading,
      onClick: this.toggle,
    })
  }
}

export default withFavouriteVenue(VenueFavouriteHandler)
